import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-sd-bridge-report',
    templateUrl: './sdBridgeReport.html',
    styleUrls: ['../../reports.css', './sdBridgeReport.css']
})

export class SDBridgeReportComponent implements OnInit {

    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;
    private bridgeKeys: any[];
    reportData;
    private readonly todaysDate = new Date().toDateString();
    private readonly headers = [
        'Proj. ID',
        'Proj. Title',
        'Improv. Type',
        'Route',
        'County',
        'TYP App',
        'TIP App',
        'Let Date',
        'Let IND',
        'Bridge Work',
        'Bridge ID',
        'Bridge RefNo.',
        'Location',
        'Status Cde',
        'Deficient/Obselete',
        'Sufficiency Rating',
        'Bridge Bill',
        'Year Built',
        'Length',
        'Deck Width',
        'Deck Area',
        'HBRR Elig.',
        'Bus Plan Network',
        'Long.',
        'Lat.',
        'Post Limit Weight',
        'Post Limit Comb.'
    ];

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Poor Bridge Condition Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.bridgeKeys = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeKeys;
            this.loadReport();
        });
    }

    private loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getSDBridgeReportData(this.bridgeKeys).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }

    public exportToCsv(): void {
        const filename = 'SDBridgeSummaryReport.csv';
        let finalValue = '';

        for (let headerIndex = 0; headerIndex < this.headers.length; headerIndex++) {
            const header = this.headers[headerIndex].replace(/,/g, '');

            if (headerIndex + 1 === this.headers.length) {
                finalValue += header + ',\n';
            } else {
                finalValue += header + ',';
            }
        }

        if (this.reportData.sdBridgeReports.length > 0) {
            const sdBridgeReports = this.reportData.sdBridgeReports;
            for (const report of sdBridgeReports) {
                finalValue += `${report.projectId},\
                    ${report.projectTitle},\
                    ${report.improvementShortDesc},\
                    ${report.stRtNo},\
                    ${report.ctyCode},\
                    ${report.typApp},\
                    ${report.tipApp},\
                    ${report.letDate},\
                    ${report.letInd},\
                    ${report.bridgeWork},\
                    I${report.bridgeId},\
                    ${report.brKey},\
                    ${report.location},\
                    ${report.postStatus},\
                    ${report.nbiRating},\
                    ${report.suffRating},\
                    ${report.bridgeBill},\
                    ${report.yearBuilt},\
                    ${report.length},\
                    ${report.deckWidth},\
                    ${report.deckArea},\
                    ${report.hbrrElig},\
                    ${report.busPlanNetwork},\
                    ${report.decLong},\
                    ${report.declat},\
                    ${report.postLimitWeight},\
                    ${report.postLimitComb}\n`;
            }
        }

        const blob = new Blob([finalValue], { type: 'text/csv;charset-utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            const myLink: any = link;
            if (myLink.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                myLink.setAttribute('href', url);
                myLink.setAttribute('download', filename);
                myLink.style.visibility = 'hidden';
                document.body.appendChild(myLink);
                myLink.click();
                document.body.removeChild(myLink);
            }
        }
    }
}
